export default __webpack_public_path__ + "static/media/services-img.75bb6b3b.png";